module.exports = __webpack_public_path__ + "static/media/Adviesbox_DOC.68963275.png";